import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-e3897ecc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "title-name"
};
var _hoisted_4 = {
  class: "question-group-info"
};
var _hoisted_5 = {
  class: "btn-box"
};
var _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "box",
      key: item.questionTypeId
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.value2label(item.questionTypeId, _ctx.QUESTION_TYPE)), 1), _createElementVNode("span", _hoisted_4, " 共" + _toDisplayString(item.questionDtoList.length) + "题 合计" + _toDisplayString(item.questionsTotalScore) + "分 ", 1)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.questionDtoList, function (question, index) {
      return _openBlock(), _createElementBlock("div", {
        key: question.id,
        class: _normalizeClass(['btn-index', question.questionStatus, {
          selected: question.selected
        }, {
          disabled: !_ctx.IS_QUESTION_TYPE_PROGRAM(question.questionTypeId) && _ctx.examService.hasFinishedObjective
        }]),
        onClick: function ($event) {
          return _ctx.selectQuestion(question);
        }
      }, _toDisplayString(index + 1), 11, _hoisted_6);
    }), 128))])]);
  }), 128))]);
}